export function ThousandSeparator({number}) {
  const value = parseInt(number).toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0 });
  return <>{`${value}`}</>;
}
